"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseUsageStatus = void 0;
var LicenseUsageStatus;
(function (LicenseUsageStatus) {
    LicenseUsageStatus["ACCEPTABLE"] = "Acceptable";
    LicenseUsageStatus["EXCEEDED"] = "Exceeded";
})(LicenseUsageStatus || (exports.LicenseUsageStatus = LicenseUsageStatus = {}));
